import React, { Component, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamation,
  faUsers,
  faListCheck,
  faArrowRight,
} from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import Circles from "../../assets/images/circle.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Dashboard = () => {
  const navigate = useNavigate();

  const [countData, setCountData] = useState({});
  const [totalSurvey, setTotalSurvey] = useState(0);
  const [todaySurvey, setTodaySurvey] = useState(0);
  const [monthSurvey, setMonthSurvey] = useState(0);
  const [yearSurvey, setYearSurvey] = useState(0);

  const [filterArray, setFilterArray] = useState([]);
  const [arrayCount, setArrayCount] = useState([]);
  const [cropCount, setCropCount] = useState([]);
  const [surveyData, setSurveyData] = useState([]);
  let stateCodeLocal = sessionStorage.getItem("stateNameGlobal");
  let DstrictCodeLocal = sessionStorage.getItem("districtCodeGlobal");
  const [pendingKML, setPendingKML] = useState("");
  const [totalKML, setTotalKML] = useState("");

  useEffect(() =>{
    
    fetchDataCount()
  }, [])

  const fetchDataCount = async () => {
    const result = await axios.post(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/trancropsurvey/getCropSurveyCountByUserCode`,
      {
        "userCode": localStorage.getItem("userCodeGlobal")
      }
    );
    setCountData(result.data.dataContent[0]);
   
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const result = await axios.post(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/iuusersmapping/getUniqueIUNotifiedArea`,
      {
        stateCode: "",
        districtCode: "",
        villageCode: "",
        cropCode: "",
        cropNotificationsID: "",
      }
    );
    setTotalKML(result.data.recordCount);
    let pendingCount =
      Number(result.data.recordCount) - Number(result.data.message);
    setPendingKML(pendingCount);
  };

  useEffect(() => {
    const fetchData = async () => {
      let yearSurveyValue = 0;
      let monthSurveyValue = 0;
      let todaySurveyValue = 0;
      let totalSurveyValue = 0;

      const result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/trancropsurvey/getCropSurveyByUserCode`,
        { userCode: localStorage.getItem("userCodeGlobal") }
      );

      let formsData = result.data.dataContent;
      totalSurveyValue = formsData.length;

      var todayDate = new Date();
      var previousDate = new Date(todayDate);

      previousDate.setMonth(previousDate.getMonth() - 1);

      let filterData = [];
      let arrayCount = [];
      let cropCount = [];
      // This logic is for last 1 month survey
      filterData = formsData.filter((x) => {
        let date = new Date(
          x.createModifyByIntUser.createdOnByUC
            .split("T")[0]
            .replaceAll("-", ",")
        );
        arrayCount.push(formsData.indexOf(x));
        cropCount.push(x.cropCode);

        if (date.getFullYear() === todayDate.getFullYear()) {
          yearSurveyValue++;
          if (date.getMonth() === todayDate.getMonth()) {
            monthSurveyValue++;
            if (date.getDate() === todayDate.getDate()) {
              todaySurveyValue++;
            }
          }
        }

        return previousDate <= date && date <= todayDate;
      });

      // This logic is for last 10 survey

      filterData = formsData.slice(0, 10);

      setFilterArray(filterData);
      setMonthSurvey(monthSurveyValue);
      setYearSurvey(yearSurveyValue);
      setTotalSurvey(totalSurveyValue);
      setTodaySurvey(todaySurveyValue);
      setArrayCount(arrayCount);
      setCropCount(cropCount);
    };
    fetchData();
  }, []);

  return (
    <>
      {/* <AdminHeader />
    <AdminSideBar/> */}
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Dashboard</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Admin</li>
              <li className="breadcrumb-item active">Dashboard</li>
            </ol>
          </nav>
        </div>
        <section className="section dashboard">
          <div className="row">
            {countData.totalICurDate === 0 ? "" :   <div className="col-xxl-3 col-xl-3">
              <div className="card info-card  sales-card bg-gradient-danger card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  <h5 className="card-title text-white">
                   Active Insurance Survey <span className="text-blue">| Today</span>
                  </h5>

                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faUsers} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      <h6>{countData.totalICurDate}</h6>
                      {/* <span className="text-success small pt-1 fw-bold">5%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          
          {countData.totalIMonthWise === 0 ? "" :  <div className="col-xxl-3 col-xl-3">
              <div className="card info-card  sales-card bg-gradient-primary card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  <h5 className="card-title text-white">
                    Active Insurance Survey <span className="text-blue">| Month</span>
                  </h5>

                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faUsers} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      <h6>{countData.totalIMonthWise}</h6>
                      {/* <span className="text-success small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>}

            {countData.totalIYearWise === 0 ? "" : <div className="col-xxl-3 col-md-3">
              <div className="card info-card  sales-card bg-gradient-success card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  <h5 className="card-title text-white">
                    Active Insurance Survey <span className="text-blue">| This Year</span>
                  </h5>

                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faUsers} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      <h6>{countData.totalIYearWise}</h6>
                      {/* <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div> }
           
           { countData.totalIOverall === 0 ? "" :  <div className="col-xxl-3 col-xl-3">
              <div className="card info-card  sales-card bg-gradient-info card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  <h5 className="card-title text-white">
                    Active Insurance Survey <span className="text-blue">| Overall</span>
                  </h5>

                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faUsers} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      <h6>{countData.totalIOverall}</h6>
                      {/* <span className="text-danger small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">decrease</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

           }
           
          {/* </div>

          <div className="row">  */}
          {
            countData.totalGCurDate === 0 ? "" :   <div className="col-xxl-3 col-xl-3">
            <div className="card info-card  sales-card bg-gradient-danger card-img-holder">
              <div className="card-body">
                <img
                  src={Circles}
                  className="card-img-absolute"
                  alt="circle-image"
                />
                <h5 className="card-title text-white">
                  Active Government Survey <span className="text-blue">| Today</span>
                </h5>

                <div className="d-flex align-items-center">
                  <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                    <i>
                      <FontAwesomeIcon icon={faUsers} />{" "}
                    </i>
                  </div>
                  <div className="ps-3">
                    <h6>{countData.totalGCurDate}</h6>
                    {/* <span className="text-success small pt-1 fw-bold">5%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
          {countData.totalGMonthWise === 0 ? "" : <div className="col-xxl-3 col-xl-3">
              <div className="card info-card  sales-card bg-gradient-primary card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  <h5 className="card-title text-white">
                    Active Government Survey <span className="text-blue"> | Month</span>
                  </h5>

                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faUsers} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      <h6>{countData.totalGMonthWise}</h6>
                      {/* <span className="text-success small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div> }
           {
            countData.totalGYearWise === 0 ? "" : <div className="col-xxl-3 col-md-3">
            <div className="card info-card  sales-card bg-gradient-success card-img-holder">
              <div className="card-body">
                <img
                  src={Circles}
                  className="card-img-absolute"
                  alt="circle-image"
                />
                <h5 className="card-title text-white">
                  Active Government Survey <span className="text-blue">| This Year</span>
                </h5>

                <div className="d-flex align-items-center">
                  <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                    <i>
                      <FontAwesomeIcon icon={faUsers} />{" "}
                    </i>
                  </div>
                  <div className="ps-3">
                    <h6>{countData.totalGYearWise}</h6>
                    {/* <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
           }
            {
              countData.totalGOverall === 0 ? "" :   <div className="col-xxl-3 col-xl-3">
              <div className="card info-card  sales-card bg-gradient-info card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  <h5 className="card-title text-white">
                    Active Government Survey <span className="text-blue">| Overall</span>
                  </h5>

                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faUsers} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      <h6>{countData.totalGOverall}</h6>
                      {/* <span className="text-danger small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">decrease</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }
          
          </div>


          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="filter">
                      <a className="icon" href="#" data-bs-toggle="dropdown">
                        <i className="bi bi-three-dots"></i>
                      </a>
                      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <li className="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>

                        <li>
                          <a className="dropdown-item" href="#">
                            Today
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            This Month
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            This Year
                          </a>
                        </li>
                      </ul>
                    </div>

                    {/* <div className="card-body">
              <h5 className="card-title">Daily Progress <span>/Today</span></h5>

              <div id="reportsChart"></div>
              <Chart type="bar" series={[{
  name:'series-1',
  data: cropCount
}]} options={{
Chart:{
  id: 'apexchart-example'
},
xaxis:{
  categories: arrayCount
}
 }} height={450} />
              </div> */}
                  </div>
                </div>

                {sessionStorage.getItem("userRoleName").includes("Central") ? (
                  <div className="col-12">
                    <div className="card recent-sales overflow-auto">
                      <div className="card-body">
                        <h5 className="card-title">
                          {" "}
                          <i>
                            <FontAwesomeIcon icon={faListCheck} />{" "}
                          </i>{" "}
                          Task List{" "}
                        </h5>

                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col">Task Name</th>
                              <th scope="col">Completed</th>
                              <th scope="col">Pending</th>
                              <th scope="col">Total</th>
                              <th scope="col">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th scope="row">KML File Upload</th>
                              <td>{totalKML - pendingKML}</td>
                              <td>{pendingKML}</td>
                              <td>{totalKML}</td>
                              <td>
                                {" "}
                                <button
                                  type="button"
                                  className="btn btn-link"
                                  onClick={() =>
                                    navigate(
                                      "/usermanagement/uploadsurveylocation"
                                    )
                                  }
                                >
                                  {" "}
                                  Go
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="col-12">
                  <div className="card recent-sales overflow-auto">
                    <div className="filter">
                      <a className="icon" href="#" data-bs-toggle="dropdown">
                        <i className="bi bi-three-dots"></i>
                      </a>
                      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <li className="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>

                        <li>
                          <a className="dropdown-item" href="#">
                            Today
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            This Month
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            This Year
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="card-body">
                      <h5 className="card-title">
                        Recent Survey <span>| Last 10 Survey</span>
                      </h5>

                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">User Name</th>
                            <th scope="col">Season Name</th>
                            <th scope="col">Crop Name</th>
                            <th scope="col">State Name</th>
                            <th scope="col">District Name</th>
                            <th scope="col">IU Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filterArray
                            ? filterArray.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <th scope="row">{item.userName}</th>
                                    <td>{item.seasonName}</td>
                                    <td>{item.cropName}</td>
                                    <td>{item.stateName}</td>
                                    <td>{item.districtName}</td>
                                    <td>{item.iuName}</td>
                                  </tr>
                                );
                              })
                            : ""}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      {/* <AdminFooter/> */}
    </>
  );
};

export default Dashboard;
